import React, { MouseEventHandler, useState } from 'react';
import { TextField } from '@material-ui/core';
import { get } from 'lodash';
import { IntlShape, injectIntl } from 'react-intl';

import { translate } from 'containers/services/translate';
import { IJudgementAdd } from 'containers/LawyerLegalProceedingsPage/typings';
import { toast } from 'react-toastify';
import { ALL_STATUS } from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/constants';
import currentUserStorage from 'containers/services/security/current-user-storage';
import messages from 'containers/CourtManagerLegalProceedings/JudgementAdd/messages';
import { RefusalDialogWrapper } from 'containers/CourtManagerLegalProceedings/JudgementAdd/styled-components';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { PROCEDURE_STEPS } from 'containers/data-structure';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import { validateAfterRejection } from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/utils';

export interface PronouncingRejectionDialogProps {
  intl: IntlShape;
  handleCancel: MouseEventHandler;
  isRefuseDialogOpen: boolean;
  claimId: number;
  judgementAdd?: IJudgementAdd | {};
  lawyer: string;
  judgementAddDocument: JudgementADDDocumentType;
  claimNumber?: string;
  setJudgementAdd?: Function;
  requestMakeJudgementAddDocumentDecision?: Function;
  setOpenFeeNoteDialog: Function;
}

const PronouncingRejectionDialog: React.FC<PronouncingRejectionDialogProps> = (
  props,
): JSX.Element => {
  const [rejectionReason, setRejectionReason] = useState<string>('');

  const handleChange = (
    e: React.ChangeEvent<{ value: string; name: string }>,
  ) => {
    setRejectionReason(e.target.value);
  };
  const onRejection = () => {
    const judgementAddDocuments = get(
      props.judgementAdd,
      'judgementAddDocuments',
      [],
    ).map((jadd: JudgementADDDocumentType) => {
      return jadd.id === props.judgementAddDocument.id
        ? { ...jadd, status: ALL_STATUS.REJECTED, rejectionReason }
        : jadd;
    });
    props.setJudgementAdd &&
      props.setJudgementAdd({
        ...props.judgementAdd,
        judgementAddDocuments,
      });

    props.requestMakeJudgementAddDocumentDecision &&
      props.requestMakeJudgementAddDocumentDecision(
        {
          judiciaryProcessId: get(props.judgementAdd, 'judiciaryProcessId'),
          id: get(props.judgementAddDocument, 'id'),
          step: PROCEDURE_STEPS.ARRET_ADD,
          procedureType: PROCEDURE_TYPES.APPEAL,
          username: currentUserStorage.get().username,
          claimId: props.claimId,
          status: ALL_STATUS.REJECTED,
          rejectionReason,
          claimNumber: props.claimNumber,
          toUpdate: false,
          isInboxesActive: featureService.hasFeature(
            FEATURES.ATTRIBUTION_INBOXES_MANAGER,
          ),
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
        },
        successCallBack,
      );
  };
  const successCallBack = () => {
    toast.success(
      translate(messages.courtManagerRefusalDialogSuccessMessage, props, {
        lawyer: props.lawyer,
      }),
    );
    featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE) &&
      props.setOpenFeeNoteDialog(true);
    const event = {} as React.MouseEvent<HTMLElement>;
    props.handleCancel(event);
  };
  return (
    <RefusalDialogWrapper
      className="refusal-content"
      handleValidate={onRejection}
      handleClose={props.handleCancel}
      title={translate(messages.courtManagerRefuseDialogTitle, props)}
      cancelTitle={translate(
        messages.courtManagerRefusalDialogReasonCancel,
        props,
      )}
      confirmTitle={translate(
        messages.courtManagerRefusalDialogReasonValidate,
        props,
      )}
      open={props.isRefuseDialogOpen}
      validateButtonDisabled={!rejectionReason}
    >
      <div className="reason-wrapper">
        {validateAfterRejection(props.judgementAddDocument) && (
          <span>
            {translate(messages.courtManagerRejectionTitleDialog, props)}
          </span>
        )}
        <TextField
          id="judgement-add-rejection-reason"
          label={translate(
            messages.courtManagerRefusalDialogReasonLabel,
            props,
          )}
          onChange={handleChange}
          value={rejectionReason}
          fullWidth
        />
      </div>
    </RefusalDialogWrapper>
  );
};
export default injectIntl(PronouncingRejectionDialog);
